module.exports = __webpack_public_path__ + "static/media/full-screen-icon.d7b278fb.svg";